// extracted by mini-css-extract-plugin
export default {"r":"style_r__pEkXn"};